import { render, staticRenderFns } from "./humid.vue?vue&type=template&id=65d9edf6&scoped=true"
import script from "./humid.vue?vue&type=script&lang=js"
export * from "./humid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9edf6",
  null
  
)

export default component.exports